
import {
  RIO_DE_JANEIRO_NEIGHBORHOODS,
  BRASILIA_NEIGHBORHOODS,
  SALVADOR_NEIGHBORHOODS,
  FORTALEZA_NEIGHBORHOODS,
  CURITIBA_NEIGHBORHOODS,
  PORTO_ALEGRE_NEIGHBORHOODS,
  GOIANIA_NEIGHBORHOODS,
  RECIFE_NEIGHBORHOODS
} from './curated-cities-neighborhoods';

export interface IBGEState {
  id: number;
  sigla: string;
  nome: string;
}

export interface IBGECity {
  id: number;
  nome: string;
}

export interface IBGEDistrict {
  id: number;
  nome: string;
  lat?: number;
  lng?: number;
  population?: number; // Para ordenação
}

export interface IBGEDemographic {
  id: string;
  label: string;
  options: { id: string; label: string }[];
}

// Lista curada oficial de São Paulo - SP (192 Bairros e Polos Mapeados com Coordenadas GPS)
const SAO_PAULO_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // ZONA SUL A
  { nome: 'Moema Pássaros', lat: -23.6025, lng: -46.6631, population: 45000 },
  { nome: 'Moema Índios', lat: -23.6078, lng: -46.6575, population: 40000 },
  { nome: 'Indianópolis', lat: -23.6122, lng: -46.6558, population: 35000 },
  { nome: 'Vila Mariana', lat: -23.5892, lng: -46.6347, population: 130000 },
  { nome: 'Chácara Klabin', lat: -23.5936, lng: -46.6264, population: 28000 },
  { nome: 'Vila Clementino', lat: -23.5986, lng: -46.6439, population: 45000 },
  { nome: 'Mirandópolis', lat: -23.6061, lng: -46.6417, population: 30000 },
  { nome: 'Paraíso', lat: -23.5767, lng: -46.6442, population: 40000 },
  { nome: 'Itaim Bibi', lat: -23.5843, lng: -46.6783, population: 90000 },
  { nome: 'Vila Olímpia', lat: -23.5956, lng: -46.6853, population: 38000 },
  { nome: 'Vila Nova Conceição', lat: -23.5914, lng: -46.6669, population: 32000 },
  { nome: 'Jardim Europa', lat: -23.5786, lng: -46.6831, population: 20000 },
  { nome: 'Brooklin Novo', lat: -23.6094, lng: -46.6914, population: 28000 },
  { nome: 'Brooklin Velho', lat: -23.6219, lng: -46.6806, population: 22000 },
  { nome: 'Campo Belo', lat: -23.6231, lng: -46.6697, population: 65000 },
  { nome: 'Jardim Aeroporto', lat: -23.6308, lng: -46.6603, population: 25000 },
  { nome: 'Saúde', lat: -23.6158, lng: -46.6389, population: 140000 },
  { nome: 'Planalto Paulista', lat: -23.6147, lng: -46.6508, population: 35000 },
  { nome: 'São Judas', lat: -23.6264, lng: -46.6403, population: 45000 },
  { nome: 'Bosque da Saúde', lat: -23.6119, lng: -46.6267, population: 40000 },
  { nome: 'Vila Gumercindo', lat: -23.6003, lng: -46.6186, population: 35000 },
  { nome: 'Jardim da Saúde', lat: -23.6211, lng: -46.6194, population: 30000 },
  { nome: 'Cursino', lat: -23.6178, lng: -46.6083, population: 100000 },
  { nome: 'Ipiranga', lat: -23.5925, lng: -46.6067, population: 110000 },
  { nome: 'Alto do Ipiranga', lat: -23.6028, lng: -46.6039, population: 45000 },
  { nome: 'Sacomã', lat: -23.6083, lng: -46.5975, population: 250000 },
  { nome: 'Vila Carioca', lat: -23.5972, lng: -46.5917, population: 25000 },
  { nome: 'Moinho Velho', lat: -23.6139, lng: -46.5931, population: 20000 },

  // ZONA SUL B
  { nome: 'Santo Amaro Centro', lat: -23.6548, lng: -46.7094, population: 75000 },
  { nome: 'Alto da Boa Vista', lat: -23.6425, lng: -46.6978, population: 35000 },
  { nome: 'Granja Julieta', lat: -23.6358, lng: -46.7072, population: 25000 },
  { nome: 'Chácara Santo Antônio', lat: -23.6289, lng: -46.7042, population: 40000 },
  { nome: 'Chácara Flora', lat: -23.6514, lng: -46.6897, population: 18000 },
  { nome: 'Jardim Marajoara', lat: -23.6683, lng: -46.6872, population: 55000 },
  { nome: 'Campo Grande', lat: -23.6792, lng: -46.6897, population: 115000 },
  { nome: 'Jabaquara', lat: -23.6472, lng: -46.6433, population: 220000 },
  { nome: 'Vila Santa Catarina', lat: -23.6586, lng: -46.6572, population: 65000 },
  { nome: 'Cidade Vargas', lat: -23.6511, lng: -46.6347, population: 30000 },
  { nome: 'Cidade Ademar', lat: -23.6744, lng: -46.6575, population: 260000 },
  { nome: 'Pedreira', lat: -23.7120, lng: -46.6520, population: 150000 },
  { nome: 'Morumbi', lat: -23.6022, lng: -46.7198, population: 45000 },
  { nome: 'Real Parque', lat: -23.6125, lng: -46.7028, population: 22000 },
  { nome: 'Jardim Everest', lat: -23.5858, lng: -46.7119, population: 18000 },
  { nome: 'Panamby', lat: -23.6269, lng: -46.7264, population: 35000 },
  { nome: 'Vila Andrade', lat: -23.6310, lng: -46.7310, population: 150000 },
  { nome: 'Portal do Morumbi', lat: -23.6086, lng: -46.7461, population: 50000 },
  { nome: 'Vila Sônia', lat: -23.5936, lng: -46.7369, population: 110000 },
  { nome: 'Jardim Peri Peri', lat: -23.5850, lng: -46.7319, population: 40000 },
  { nome: 'Socorro', lat: -23.6881, lng: -46.7125, population: 40000 },
  { nome: 'Interlagos', lat: -23.7028, lng: -46.6975, population: 65000 },
  { nome: 'Vila Friburgo', lat: -23.6947, lng: -46.7042, population: 20000 },
  { nome: 'Cidade Dutra', lat: -23.7144, lng: -46.6978, population: 200000 },
  { nome: 'Jardim Primavera', lat: -23.7292, lng: -46.6944, population: 45000 },
  { nome: 'Grajaú', lat: -23.7547, lng: -46.6961, population: 390000 },
  { nome: 'Parque América', lat: -23.7419, lng: -46.6958, population: 50000 },
  { nome: 'Capão Redondo', lat: -23.6669, lng: -46.7797, population: 280000 },
  { nome: 'Parque Fernanda', lat: -23.6789, lng: -46.7914, population: 35000 },
  { nome: 'Jardim São Luís', lat: -23.6558, lng: -46.7417, population: 270000 },
  { nome: 'Jardim Ângela', lat: -23.7020, lng: -46.7820, population: 300000 },
  { nome: 'Parelheiros', lat: -23.7914, lng: -46.7214, population: 150000 },

  // ZONA OESTE
  { nome: 'Pinheiros Centro', lat: -23.5670, lng: -46.6930, population: 65000 },
  { nome: 'Alto de Pinheiros', lat: -23.5480, lng: -46.7080, population: 45000 },
  { nome: 'Jardim Paulistano', lat: -23.5714, lng: -46.6853, population: 35000 },
  { nome: 'Vila Madalena', lat: -23.5540, lng: -46.6910, population: 35000 },
  { nome: 'Sumarezinho', lat: -23.5469, lng: -46.6892, population: 22000 },
  { nome: 'Perdizes', lat: -23.5380, lng: -46.6710, population: 110000 },
  { nome: 'Sumaré', lat: -23.5422, lng: -46.6797, population: 30000 },
  { nome: 'Vila Pompeia', lat: -23.5317, lng: -46.6828, population: 45000 },
  { nome: 'Lapa Centro', lat: -23.5220, lng: -46.7020, population: 65000 },
  { nome: 'Alto da Lapa', lat: -23.5294, lng: -46.7119, population: 30000 },
  { nome: 'Lapa de Baixo', lat: -23.5139, lng: -46.6958, population: 25000 },
  { nome: 'Vila Romana', lat: -23.5286, lng: -46.6936, population: 35000 },
  { nome: 'Vila Ipojuca', lat: -23.5358, lng: -46.7033, population: 20000 },
  { nome: 'Barra Funda', lat: -23.5260, lng: -46.6620, population: 15000 },
  { nome: 'Água Branca', lat: -23.5217, lng: -46.6789, population: 25000 },
  { nome: 'Vila Leopoldina', lat: -23.5290, lng: -46.7320, population: 40000 },
  { nome: 'Ceasa / Ceagesp', lat: -23.5358, lng: -46.7389, population: 10000 },
  { nome: 'Jaguaré', lat: -23.5410, lng: -46.7510, population: 50000 },
  { nome: 'Parque Continental', lat: -23.5458, lng: -46.7644, population: 20000 },
  { nome: 'Butantã', lat: -23.5710, lng: -46.7150, population: 55000 },
  { nome: 'Cidade Universitária (USP)', lat: -23.5614, lng: -46.7308, population: 12000 },
  { nome: 'Caxingui', lat: -23.5819, lng: -46.7267, population: 30000 },
  { nome: 'Jardim Bonfiglioli', lat: -23.5786, lng: -46.7456, population: 60000 },
  { nome: 'Vila Gomes', lat: -23.5719, lng: -46.7261, population: 25000 },
  { nome: 'Rio Pequeno', lat: -23.5740, lng: -46.7620, population: 125000 },
  { nome: 'Raposo Tavares', lat: -23.5910, lng: -46.7850, population: 105000 },

  // ZONA LESTE A
  { nome: 'Tatuapé Centro', lat: -23.5400, lng: -46.5760, population: 95000 },
  { nome: 'Vila Gomes Cardim', lat: -23.5458, lng: -46.5689, population: 40000 },
  { nome: 'Maranhão / Tatuapé Norte', lat: -23.5317, lng: -46.5786, population: 30000 },
  { nome: 'Jardim Anália Franco', lat: -23.5550, lng: -46.5620, population: 50000 },
  { nome: 'Jardim Têxtil', lat: -23.5647, lng: -46.5519, population: 35000 },
  { nome: 'Mooca Centro', lat: -23.5580, lng: -46.6020, population: 75000 },
  { nome: 'Alto da Mooca', lat: -23.5658, lng: -46.5894, population: 45000 },
  { nome: 'Parque da Mooca', lat: -23.5742, lng: -46.5967, population: 30000 },
  { nome: 'Hipódromo', lat: -23.5492, lng: -46.6069, population: 20000 },
  { nome: 'Belém', lat: -23.5380, lng: -46.5950, population: 45000 },
  { nome: 'Catumbi', lat: -23.5319, lng: -46.5986, population: 25000 },
  { nome: 'Quarta Parada', lat: -23.5458, lng: -46.5911, population: 20000 },
  { nome: 'Água Rasa', lat: -23.5580, lng: -46.5720, population: 85000 },
  { nome: 'Vila Regente Feijó', lat: -23.5519, lng: -46.5789, population: 30000 },
  { nome: 'Vila Formosa', lat: -23.5680, lng: -46.5450, population: 95000 },
  { nome: 'Vila Antonina', lat: -23.5619, lng: -46.5386, population: 30000 },
  { nome: 'Vila Prudente', lat: -23.5850, lng: -46.5820, population: 105000 },
  { nome: 'Vila Zelina', lat: -23.5917, lng: -46.5742, population: 35000 },
  { nome: 'Quinta da Paineira', lat: -23.5789, lng: -46.5914, population: 20000 },
  { nome: 'Vila Carrão', lat: -23.5450, lng: -46.5350, population: 85000 },
  { nome: 'Chácara Califórnia', lat: -23.5392, lng: -46.5469, population: 25000 },
  { nome: 'Penha de França', lat: -23.5250, lng: -46.5420, population: 130000 },
  { nome: 'Vila Esperança', lat: -23.5286, lng: -46.5258, population: 40000 },
  { nome: 'Vila Matilde', lat: -23.5350, lng: -46.5220, population: 105000 },
  { nome: 'Vila Dalila', lat: -23.5461, lng: -46.5139, population: 35000 },
  { nome: 'Cidade Patriarca', lat: -23.5369, lng: -46.5014, population: 50000 },
  { nome: 'Vila Guilhermina', lat: -23.5342, lng: -46.5139, population: 35000 },
  { nome: 'Artur Alvim', lat: -23.5410, lng: -46.4850, population: 105000 },

  // ZONA LESTE B
  { nome: 'Itaquera Centro', lat: -23.5410, lng: -46.4550, population: 210000 },
  { nome: 'Vila Carmosina', lat: -23.5489, lng: -46.4631, population: 45000 },
  { nome: 'Parque do Carmo', lat: -23.5750, lng: -46.4680, population: 70000 },
  { nome: 'Cidade Líder', lat: -23.5650, lng: -46.4820, population: 130000 },
  { nome: 'José Bonifácio / Cohab 2', lat: -23.5380, lng: -46.4280, population: 125000 },
  { nome: 'Parque Savoy City', lat: -23.5719, lng: -46.4956, population: 30000 },
  { nome: 'Aricanduva Centro', lat: -23.5780, lng: -46.5150, population: 90000 },
  { nome: 'Jardim Aricanduva', lat: -23.5856, lng: -46.5089, population: 40000 },
  { nome: 'São Mateus Centro', lat: -23.6010, lng: -46.4780, population: 155000 },
  { nome: 'São Rafael', lat: -23.6214, lng: -46.4689, population: 80000 },
  { nome: 'Jardim Iguatemi', lat: -23.6058, lng: -46.4522, population: 55000 },
  { nome: 'Jardim Colonial', lat: -23.5958, lng: -46.4639, population: 45000 },
  { nome: 'Sapopemba Centro', lat: -23.6080, lng: -46.5120, population: 290000 },
  { nome: 'Vila Tolstói', lat: -23.5989, lng: -46.5367, population: 45000 },
  { nome: 'Fazenda da Juta', lat: -23.6125, lng: -46.4958, population: 60000 },
  { nome: 'Teotônio Vilela', lat: -23.6050, lng: -46.5028, population: 50000 },
  { nome: 'Cangaíba', lat: -23.5080, lng: -46.5250, population: 140000 },
  { nome: 'Engenheiro Goulart', lat: -23.4986, lng: -46.5214, population: 40000 },
  { nome: 'Jardim Danfer', lat: -23.5058, lng: -46.5119, population: 35000 },
  { nome: 'Ermelino Matarazzo Centro', lat: -23.4880, lng: -46.4950, population: 115000 },
  { nome: 'Ponte Rasa', lat: -23.5080, lng: -46.4920, population: 95000 },
  { nome: 'São Miguel Paulista Centro', lat: -23.4950, lng: -46.4420, population: 95000 },
  { nome: 'Vila Jacuí', lat: -23.5086, lng: -46.4567, population: 45000 },
  { nome: 'Jardim Helena', lat: -23.4828, lng: -46.4386, population: 70000 },
  { nome: 'Vila Curuçá', lat: -23.5020, lng: -46.4180, population: 155000 },
  { nome: 'Itaim Paulista Centro', lat: -23.4920, lng: -46.3980, population: 240000 },
  { nome: 'Jardim Romano', lat: -23.4839, lng: -46.3889, population: 50000 },
  { nome: 'Guaianases Centro', lat: -23.5450, lng: -46.4150, population: 170000 },
  { nome: 'Lajeado', lat: -23.5358, lng: -46.4022, population: 85000 },
  { nome: 'Cidade Tiradentes', lat: -23.5950, lng: -46.3950, population: 230000 },

  // ZONA NORTE
  { nome: 'Santana Centro', lat: -23.5020, lng: -46.6280, population: 120000 },
  { nome: 'Jardim São Paulo', lat: -23.4925, lng: -46.6189, population: 40000 },
  { nome: 'Santa Teresinha', lat: -23.4958, lng: -46.6367, population: 35000 },
  { nome: 'Água Fria', lat: -23.4867, lng: -46.6186, population: 30000 },
  { nome: 'Tucuruvi Centro', lat: -23.4790, lng: -46.6020, population: 100000 },
  { nome: 'Parada Inglesa', lat: -23.4869, lng: -46.6086, population: 30000 },
  { nome: 'Mandaqui', lat: -23.4810, lng: -46.6350, population: 110000 },
  { nome: 'Casa Verde Centro', lat: -23.5080, lng: -46.6580, population: 85000 },
  { nome: 'Casa Verde Alta', lat: -23.4975, lng: -46.6625, population: 45000 },
  { nome: 'Limão', lat: -23.5090, lng: -46.6820, population: 80000 },
  { nome: 'Freguesia do Ó', lat: -23.4980, lng: -46.6980, population: 145000 },
  { nome: 'Itaberaba', lat: -23.4867, lng: -46.6914, population: 50000 },
  { nome: 'Brasilândia', lat: -23.4680, lng: -46.6890, population: 270000 },
  { nome: 'Cachoeirinha / Vila Nova Cachoeirinha', lat: -23.4650, lng: -46.6580, population: 150000 },
  { nome: 'Vila Maria Centro', lat: -23.5150, lng: -46.5880, population: 115000 },
  { nome: 'Parque Novo Mundo', lat: -23.5086, lng: -46.5744, population: 40000 },
  { nome: 'Vila Guilherme', lat: -23.5120, lng: -46.6080, population: 55000 },
  { nome: 'Vila Medeiros', lat: -23.4920, lng: -46.5850, population: 135000 },
  { nome: 'Jaçanã', lat: -23.4580, lng: -46.5820, population: 95000 },
  { nome: 'Tremembé', lat: -23.4480, lng: -46.6220, population: 200000 },
  { nome: 'Pirituba Centro', lat: -23.4880, lng: -46.7280, population: 170000 },
  { nome: 'City América', lat: -23.5019, lng: -46.7358, population: 25000 },
  { nome: 'Jaraguá Centro', lat: -23.4480, lng: -46.7450, population: 190000 },
  { nome: 'Taipas', lat: -23.4389, lng: -46.7214, population: 60000 },
  { nome: 'São Domingos', lat: -23.5050, lng: -46.7450, population: 85000 },
  { nome: 'Anhanguera', lat: -23.4150, lng: -46.7850, population: 70000 },

  // CENTRO
  { nome: 'Bela Vista', lat: -23.5580, lng: -46.6450, population: 75000 },
  { nome: 'Bixiga', lat: -23.5542, lng: -46.6478, population: 30000 },
  { nome: 'Consolação', lat: -23.5510, lng: -46.6580, population: 60000 },
  { nome: 'Higienópolis', lat: -23.5458, lng: -46.6569, population: 45000 },
  { nome: 'Pacaembu', lat: -23.5428, lng: -46.6669, population: 25000 },
  { nome: 'Cerqueira César', lat: -23.5614, lng: -46.6658, population: 40000 },
  { nome: 'República', lat: -23.5430, lng: -46.6420, population: 60000 },
  { nome: 'Sé / Centro Histórico', lat: -23.5505, lng: -46.6333, population: 30000 },
  { nome: 'São Bento / Anhangabaú', lat: -23.5458, lng: -46.6361, population: 20000 },
  { nome: 'Liberdade Centro', lat: -23.5620, lng: -46.6320, population: 70000 },
  { nome: 'Aclimação', lat: -23.5714, lng: -46.6308, population: 45000 },
  { nome: 'Cambuci', lat: -23.5680, lng: -46.6220, population: 40000 },
  { nome: 'Glicério', lat: -23.5558, lng: -46.6278, population: 25000 },
  { nome: 'Santa Cecília', lat: -23.5350, lng: -46.6520, population: 90000 },
  { nome: 'Vila Buarque', lat: -23.5450, lng: -46.6514, population: 35000 },
  { nome: 'Campos Elíseos', lat: -23.5328, lng: -46.6456, population: 30000 },
  { nome: 'Bom Retiro', lat: -23.5280, lng: -46.6380, population: 35000 },
  { nome: 'Luz', lat: -23.5342, lng: -46.6347, population: 25000 },
  { nome: 'Brás Centro', lat: -23.5410, lng: -46.6180, population: 30000 },
  { nome: 'Pari', lat: -23.5280, lng: -46.6150, population: 18000 },
  { nome: 'Canindé', lat: -23.5219, lng: -46.6186, population: 15000 },
  { nome: 'Santa Ifigênia', lat: -23.5392, lng: -46.6378, population: 20000 }
];

// Lista curada de BH para garantir fidelidade e ordenação por população
const BH_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Sagrada Família', population: 34347, lat: -19.9072, lng: -43.9189 },
  { nome: 'Buritis', population: 29374, lat: -19.9712, lng: -43.9642 },
  { nome: 'Castelo', population: 18500, lat: -19.8795, lng: -43.9912 },
  { nome: 'Santa Amélia', population: 16200, lat: -19.8472, lng: -43.9745 },
  { nome: 'Alípio de Melo', population: 15286, lat: -19.8908, lng: -43.9898 },
  { nome: 'Padre Eustáquio', population: 15196, lat: -19.9175, lng: -43.9608 },
  { nome: 'Sion', population: 15035, lat: -19.9558, lng: -43.9302 },
  { nome: 'Lindéia', population: 14832, lat: -19.9708, lng: -44.0318 },
  { nome: 'Serra', population: 14819, lat: -19.9438, lng: -43.9198 },
  { nome: 'Gutierrez', population: 14613, lat: -19.9358, lng: -43.9528 },
  { nome: 'Ouro Preto', population: 14000, lat: -19.8722, lng: -43.9818 },
  { nome: 'Caiçara', population: 13500, lat: -19.8978, lng: -43.9612 },
  { nome: 'Carlos Prates', population: 13000, lat: -19.9108, lng: -43.9508 },
  { nome: 'Itapoã', population: 12500, lat: -19.8388, lng: -43.9578 },
  { nome: 'Dona Clara', population: 12000, lat: -19.8558, lng: -43.9538 },
  { nome: 'Jaraguá', population: 11500, lat: -19.8625, lng: -43.9548 },
  { nome: 'Planalto', population: 11000, lat: -19.8288, lng: -43.9512 },
  { nome: 'Heliópolis', population: 10500, lat: -19.8378, lng: -43.9378 },
  { nome: 'São Gabriel', population: 10000, lat: -19.8578, lng: -43.9148 },
  { nome: 'Prado', population: 9800, lat: -19.9238, lng: -43.9581 },
  { nome: 'Barroca', population: 9500, lat: -19.9308, lng: -43.9618 },
  { nome: 'Calafate', population: 9200, lat: -19.9248, lng: -43.9688 },
  { nome: 'Grajaú', population: 9000, lat: -19.9408, lng: -43.9648 },
  { nome: 'Nova Suíça', population: 8800, lat: -19.9318, lng: -43.9712 },
  { nome: 'Salgado Filho', population: 8500, lat: -19.9478, lng: -43.9812 },
  { nome: 'Estoril', population: 8200, lat: -19.9622, lng: -43.9678 },
  { nome: 'Belvedere', population: 8000, lat: -19.9792, lng: -43.9351 },
  { nome: 'Mangabeiras', population: 7800, lat: -19.9528, lng: -43.9118 },
  { nome: 'Anchieta', population: 7500, lat: -19.9458, lng: -43.9278 },
  { nome: 'Cruzeiro', population: 7200, lat: -19.9428, lng: -43.9248 },
  { nome: 'Lourdes', population: 7000, lat: -19.9285, lng: -43.9431 },
  { nome: 'Savassi', population: 6800, lat: -19.9381, lng: -43.9332 },
  { nome: 'Funcionários', population: 6500, lat: -19.9318, lng: -43.9295 },
  { nome: 'Santa Efigênia', population: 6300, lat: -19.9248, lng: -43.9212 },
  { nome: 'Floresta', population: 6000, lat: -19.9128, lng: -43.9282 },
  { nome: 'Cidade Nova', population: 14500, lat: -19.8860, lng: -43.9210 },
  { nome: 'Santa Tereza', population: 5200, lat: -19.9151, lng: -43.9182 },
  { nome: 'São Bento', population: 4800, lat: -19.9588, lng: -43.9378 },
  { nome: 'Bandeirantes', population: 4500, lat: -19.8558, lng: -43.9892 },
  { nome: 'São Luiz', population: 4300, lat: -19.8525, lng: -43.9722 },
  { nome: 'Diamante', population: 3900, lat: -19.9880, lng: -44.0208 },
  { nome: 'Milionários', population: 3700, lat: -19.9788, lng: -44.0278 },
  { nome: 'Candelária', population: 3300, lat: -19.8182, lng: -43.9648 },
  { nome: 'Leticia', population: 3100, lat: -19.8082, lng: -43.9618 },
  { nome: 'Santo Agostinho', population: 9800, lat: -19.9268, lng: -43.9468 },
  { nome: 'Luxemburgo', population: 8500, lat: -19.9452, lng: -43.9428 },
  { nome: 'Barreiro', population: 150000, lat: -19.9728, lng: -44.0194 },
  { nome: 'Venda Nova', population: 120000, lat: -19.8052, lng: -43.9498 },
  { nome: 'Palmares', population: 11000, lat: -19.8748, lng: -43.9178 },
  { nome: 'Coração Eucarístico', population: 10500, lat: -19.9208, lng: -43.9828 },
  { nome: 'Gameleira', population: 9200, lat: -19.9318, lng: -43.9878 },
  { nome: 'Betânia', population: 14000, lat: -19.9618, lng: -43.9882 },
  { nome: 'Havaí', population: 8500, lat: -19.9538, lng: -43.9812 },
  { nome: 'Céu Azul', population: 11500, lat: -19.8148, lng: -43.9878 },
  { nome: 'Paquetá', population: 7500, lat: -19.8682, lng: -43.9978 },
  { nome: 'Urca', population: 8200, lat: -19.8808, lng: -44.0078 },
  { nome: 'Manacás', population: 6800, lat: -19.8888, lng: -44.0078 },
  { nome: 'Glória', population: 9500, lat: -19.8978, lng: -43.9948 },
  { nome: 'Serrano', population: 13000, lat: -19.8918, lng: -44.0148 },
  { nome: 'Aparício', population: 5500, lat: -19.9350, lng: -43.9050 },
  { nome: 'Cachoeirinha', population: 9800, lat: -19.8888, lng: -43.9488 },
  { nome: 'Renascença', population: 8700, lat: -19.8810, lng: -43.9408 },
  { nome: 'Ipiranga', population: 11000, lat: -19.8752, lng: -43.9378 }
];

const CONTAGEM_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // Regional Eldorado
  { nome: 'Eldorado', population: 30000, lat: -19.9535, lng: -44.0175 },
  { nome: 'Novo Eldorado', population: 15000, lat: -19.9485, lng: -44.0245 },
  { nome: 'Glória', population: 12000, lat: -19.9431, lng: -44.0118 },
  { nome: 'Água Branca', population: 14000, lat: -19.9585, lng: -44.0045 },
  { nome: 'Cinco (Distrito Industrial)', population: 8000, lat: -19.9675, lng: -44.0410 },
  { nome: 'JK', population: 7000, lat: -19.9722, lng: -44.0195 },
  { nome: 'Bela Vista', population: 6000, lat: -19.9480, lng: -44.0090 },
  { nome: 'Santa Cruz Industrial', population: 8000, lat: -19.9555, lng: -44.0325 },

  // Regional Sede
  { nome: 'Sede', population: 15000, lat: -19.9168, lng: -44.0881 },
  { nome: 'Centro de Contagem', population: 15000, lat: -19.9168, lng: -44.0881 },
  { nome: 'Alvorada', population: 11000, lat: -19.9215, lng: -44.0785 },
  { nome: 'Fonte Grande', population: 8000, lat: -19.9145, lng: -44.0825 },
  { nome: 'Santa Helena', population: 7000, lat: -19.9110, lng: -44.0865 },
  { nome: 'Bernardo Monteiro', population: 9000, lat: -19.9315, lng: -44.1035 },
  { nome: 'Europa', population: 5000, lat: -19.9075, lng: -44.0945 },
  { nome: 'Los Ángeles', population: 4000, lat: -19.9385, lng: -44.0915 },
  { nome: 'Linda Vista', population: 6000, lat: -19.9045, lng: -44.0825 },

  // Regional Ressaca
  { nome: 'Ressaca', population: 25000, lat: -19.8950, lng: -44.0050 },
  { nome: 'Cabral', population: 22000, lat: -19.8825, lng: -43.9995 },
  { nome: 'Arvoredo', population: 14000, lat: -19.8885, lng: -44.0085 },
  { nome: 'Jardim Laguna', population: 18000, lat: -19.9045, lng: -44.0185 },
  { nome: 'Joaquim Murtinho', population: 10000, lat: -19.8975, lng: -44.0145 },
  { nome: 'Guanabara', population: 12000, lat: -19.9115, lng: -44.0115 },
  { nome: 'Balneário da Ressaca', population: 16000, lat: -19.9025, lng: -44.0025 },
  { nome: 'Novo Progresso', population: 18000, lat: -19.9085, lng: -44.0275 },

  // Regional Industrial
  { nome: 'Industrial', population: 25000, lat: -19.9685, lng: -44.0015 },
  { nome: 'Amazonas', population: 18000, lat: -19.9625, lng: -44.0115 },
  { nome: 'Inconfidentes', population: 14000, lat: -19.9575, lng: -44.0355 },
  { nome: 'Vila Barragão', population: 6000, lat: -19.9725, lng: -44.0055 },
  { nome: 'Bandeirantes', population: 12000, lat: -19.9455, lng: -44.0015 },

  // Regional Riacho
  { nome: 'Riacho', population: 20000, lat: -19.9655, lng: -44.0585 },
  { nome: 'Jardim Riacho das Pedras', population: 20000, lat: -19.9815, lng: -44.0625 },
  { nome: 'Riacho das Pedras', population: 22000, lat: -19.9655, lng: -44.0585 },
  { nome: 'Monte Castelo', population: 8000, lat: -19.9615, lng: -44.0685 },
  { nome: 'Vila Vera Cruz', population: 5000, lat: -19.9715, lng: -44.0515 },

  // Regional Nacional
  { nome: 'Nacional', population: 30000, lat: -19.8645, lng: -43.9945 },
  { nome: 'Bom Jesus', population: 15000, lat: -19.8545, lng: -44.0005 },
  { nome: 'Pedra Azul', population: 20000, lat: -19.8715, lng: -43.9885 },
  { nome: 'Xangrilá', population: 20000, lat: -19.8455, lng: -43.9915 },

  // Regional Petrolândia
  { nome: 'Petrolândia', population: 24000, lat: -19.9485, lng: -44.1385 },
  { nome: 'Industrial Belém', population: 12000, lat: -19.9535, lng: -44.1485 },
  { nome: 'Sapucaias', population: 15000, lat: -19.9595, lng: -44.1315 },
  { nome: 'Tropical', population: 14000, lat: -19.9385, lng: -44.1225 },

  // Regional Vargem das Flores
  { nome: 'Vargem das Flores', population: 25000, lat: -19.8850, lng: -44.1400 },
  { nome: 'Nova Contagem', population: 35000, lat: -19.8625, lng: -44.1555 },
  { nome: 'Retiro', population: 25000, lat: -19.8925, lng: -44.1285 },
  { nome: 'Icaivera', population: 20000, lat: -19.8685, lng: -44.2055 },
  { nome: 'Darcy Ribeiro', population: 15000, lat: -19.8895, lng: -44.1525 }
];

const BETIM_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Jardim Alterosa', population: 35000, lat: -19.9450, lng: -44.1550 },
  { nome: 'Imbiruçu', population: 28000, lat: -19.9350, lng: -44.1250 },
  { nome: 'PTB', population: 24000, lat: -20.0050, lng: -44.1750 },
  { nome: 'Teresópolis', population: 25000, lat: -19.9550, lng: -44.1100 },
  { nome: 'Laranjeiras', population: 20000, lat: -19.9320, lng: -44.1320 },
  { nome: 'Centro', population: 18000, lat: -19.9676, lng: -44.2001 },
  { nome: 'Citrolândia', population: 18000, lat: -20.0150, lng: -44.2550 },
  { nome: 'São Caetano', population: 17000, lat: -19.9280, lng: -44.1080 },
  { nome: 'Jardim Brasília', population: 16000, lat: -19.9400, lng: -44.1150 },
  { nome: 'Novo Horizonte', population: 15000, lat: -19.9620, lng: -44.1780 },
  { nome: 'Duque de Caxias', population: 15000, lat: -19.9410, lng: -44.1450 },
  { nome: 'Vila Cristina', population: 14000, lat: -19.9580, lng: -44.1020 },
  { nome: 'Icaivera', population: 14000, lat: -19.8950, lng: -44.2250 },
  { nome: 'Senhora das Graças', population: 12000, lat: -19.9600, lng: -44.1920 },
  { nome: 'Vianópolis', population: 12000, lat: -20.0350, lng: -44.2750 },
  { nome: 'Ingá', population: 11000, lat: -19.9520, lng: -44.1850 },
  { nome: 'Dom Bosco', population: 11000, lat: -19.9910, lng: -44.1880 },
  { nome: 'Bandeirinhas', population: 10000, lat: -20.0120, lng: -44.2120 },
  { nome: 'Brasiléia', population: 10000, lat: -19.9720, lng: -44.1950 },
  { nome: 'Angola', population: 9500, lat: -19.9650, lng: -44.2120 },
  { nome: 'Niterói', population: 9000, lat: -19.9700, lng: -44.2180 },
  { nome: 'Bueno Francês', population: 8000, lat: -19.9820, lng: -44.2080 },
  { nome: 'São João', population: 8000, lat: -19.9820, lng: -44.1680 },
  { nome: 'Horto', population: 7500, lat: -19.9580, lng: -44.2020 },
  { nome: 'Filadélfia', population: 7000, lat: -19.9580, lng: -44.2120 },
  { nome: 'Decamão', population: 6500, lat: -19.9740, lng: -44.1820 },
  { nome: 'Charneca', population: 6000, lat: -19.9920, lng: -44.2320 },
  { nome: 'Chácara', population: 5500, lat: -19.9800, lng: -44.1900 },
  { nome: 'Jardim das Alterosas I', population: 18000, lat: -19.9460, lng: -44.1500 },
  { nome: 'Jardim das Alterosas II', population: 22000, lat: -19.9420, lng: -44.1580 }
];

const UBERLANDIA_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Centro', population: 40000, lat: -18.9186, lng: -48.2772 },
  { nome: 'Santa Mônica', population: 35000, lat: -18.9150, lng: -48.2580 },
  { nome: 'Tibery', population: 28000, lat: -18.9020, lng: -48.2510 },
  { nome: 'Martins', population: 22000, lat: -18.9100, lng: -48.2850 },
  { nome: 'Osvaldo Rezende', population: 18000, lat: -18.9180, lng: -48.2910 },
  { nome: 'Cazeca', population: 12000, lat: -18.9240, lng: -48.2710 },
  { nome: 'Saraiva', population: 15000, lat: -18.9280, lng: -48.2620 },
  { nome: 'Brasil', population: 25000, lat: -18.9050, lng: -48.2720 },
  { nome: 'Umuarama', population: 30000, lat: -18.8850, lng: -48.2610 },
  { nome: 'Custódio Pereira', population: 16000, lat: -18.8920, lng: -48.2450 },
  { nome: 'Segismundo Pereira', population: 14000, lat: -18.9250, lng: -48.2380 },
  { nome: 'Santa Luzia', population: 20000, lat: -18.9550, lng: -48.2680 },
  { nome: 'Granada', population: 19000, lat: -18.9620, lng: -48.2550 },
  { nome: 'Roosevelt', population: 22000, lat: -18.8880, lng: -48.2880 },
  { nome: 'Luizote de Freitas', population: 32000, lat: -18.9200, lng: -48.3300 },
  { nome: 'Mansour', population: 15000, lat: -18.9320, lng: -48.3450 },
  { nome: 'Planalto', population: 21000, lat: -18.9480, lng: -48.3120 },
  { nome: 'Morada da Colina', population: 12000, lat: -18.9410, lng: -48.2750 },
  { nome: 'Jardim Finotti', population: 11000, lat: -18.9220, lng: -48.2520 },
  { nome: 'Jardim Karaíba', population: 13000, lat: -18.9480, lng: -48.2850 },
  { nome: 'Aclimação', population: 10000, lat: -18.8880, lng: -48.2320 },
  { nome: 'Marta Helena', population: 14000, lat: -18.8820, lng: -48.2780 },
  { nome: 'Nossa Senhora das Graças', population: 11000, lat: -18.8950, lng: -48.2820 },
  { nome: 'Jaraguá', population: 15000, lat: -18.9350, lng: -48.3050 },
  { nome: 'Laranjeiras', population: 18000, lat: -18.9720, lng: -48.2420 },
  { nome: 'Shopping Park', population: 24000, lat: -18.9850, lng: -48.2650 },
  { nome: 'Novo Mundo', population: 17000, lat: -18.8980, lng: -48.2180 },
  { nome: 'Cidade Jardim', population: 16000, lat: -18.9420, lng: -48.2980 }
];

const JUIZ_DE_FORA_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Centro', population: 45000, lat: -21.7642, lng: -43.3503 },
  { nome: 'Alto dos Passos', population: 18000, lat: -21.7750, lng: -43.3480 },
  { nome: 'São Mateus', population: 28000, lat: -21.7720, lng: -43.3580 },
  { nome: 'Cascatinha', population: 20000, lat: -21.7820, lng: -43.3650 },
  { nome: 'Granbery', population: 14000, lat: -21.7680, lng: -43.3420 },
  { nome: 'Santa Helena', population: 15000, lat: -21.7580, lng: -43.3490 },
  { nome: 'Paineiras', population: 12000, lat: -21.7620, lng: -43.3380 },
  { nome: 'Poço Rico', population: 11000, lat: -21.7700, lng: -43.3350 },
  { nome: 'Manoel Honório', population: 19000, lat: -21.7480, lng: -43.3450 },
  { nome: 'Bairu', population: 16000, lat: -21.7420, lng: -43.3400 },
  { nome: 'Bom Pastor', population: 13000, lat: -21.7780, lng: -43.3420 },
  { nome: 'Mariano Procópio', population: 12000, lat: -21.7480, lng: -43.3550 },
  { nome: 'Costa Carvalho', population: 10000, lat: -21.7620, lng: -43.3280 },
  { nome: 'Fábrica', population: 9000, lat: -21.7520, lng: -43.3610 },
  { nome: 'Santa Luzia', population: 25000, lat: -21.7920, lng: -43.3450 },
  { nome: 'Grama', population: 18000, lat: -21.7080, lng: -43.3180 },
  { nome: 'Benfica', population: 30000, lat: -21.6880, lng: -43.4180 },
  { nome: 'São Pedro', population: 32000, lat: -21.7720, lng: -43.3820 },
  { nome: 'Martelos', population: 11000, lat: -21.7850, lng: -43.3820 },
  { nome: 'Teixeiras', population: 17000, lat: -21.7880, lng: -43.3700 },
  { nome: 'Estrela Sul', population: 8000, lat: -21.7810, lng: -43.3580 },
  { nome: 'Marilândia', population: 14000, lat: -21.7680, lng: -43.4020 },
  { nome: 'Santos Dumont', population: 12000, lat: -21.7550, lng: -43.4080 },
  { nome: 'Nova Era', population: 16000, lat: -21.6980, lng: -43.4280 }
];

const MONTES_CLAROS_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Centro', population: 35000, lat: -16.7282, lng: -43.8578 },
  { nome: 'Todos os Santos', population: 15000, lat: -16.7220, lng: -43.8510 },
  { nome: 'Ibituruna', population: 18000, lat: -16.7450, lng: -43.8780 },
  { nome: 'Major Prates', population: 28000, lat: -16.7550, lng: -43.8520 },
  { nome: 'Melo', population: 12000, lat: -16.7320, lng: -43.8650 },
  { nome: 'Morada do Sol', population: 14000, lat: -16.7420, lng: -43.8620 },
  { nome: 'São Luiz', population: 16000, lat: -16.7150, lng: -43.8620 },
  { nome: 'Santa Rita', population: 13000, lat: -16.7180, lng: -43.8720 },
  { nome: 'Roxo Verde', population: 10000, lat: -16.7250, lng: -43.8680 },
  { nome: 'Augusta Mota', population: 15000, lat: -16.7420, lng: -43.8720 },
  { nome: 'Candida Câmara', population: 11000, lat: -16.7350, lng: -43.8720 },
  { nome: 'Renascença', population: 17000, lat: -16.7080, lng: -43.8520 },
  { nome: 'Lourdes', population: 19000, lat: -16.7120, lng: -43.8420 },
  { nome: 'São José', population: 14000, lat: -16.7380, lng: -43.8480 },
  { nome: 'Delfino Magalhães', population: 22000, lat: -16.7050, lng: -43.8320 },
  { nome: 'Maracanã', population: 20000, lat: -16.7480, lng: -43.8320 },
  { nome: 'Independência', population: 18000, lat: -16.7580, lng: -43.8420 },
  { nome: 'Jardim Panorama', population: 16000, lat: -16.7120, lng: -43.8250 },
  { nome: 'Santos Dumont', population: 21000, lat: -16.6980, lng: -43.8420 }
];

const UBERABA_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Centro', population: 30000, lat: -19.7483, lng: -47.9319 },
  { nome: 'Abadia', population: 25000, lat: -19.7580, lng: -47.9220 },
  { nome: 'São Benedito', population: 18000, lat: -19.7420, lng: -47.9380 },
  { nome: 'Estados Unidos', population: 16000, lat: -19.7520, lng: -47.9150 },
  { nome: 'Mercês', population: 15000, lat: -19.7380, lng: -47.9450 },
  { nome: 'Fabrício', population: 14000, lat: -19.7320, lng: -47.9320 },
  { nome: 'Parque das Américas', population: 22000, lat: -19.7750, lng: -47.9520 },
  { nome: 'Boa Vista', population: 20000, lat: -19.7280, lng: -47.9250 },
  { nome: 'Santa Maria', population: 17000, lat: -19.7420, lng: -47.9550 },
  { nome: 'Univerdecidade', population: 10000, lat: -19.7220, lng: -47.9620 },
  { nome: 'Olinda', population: 13000, lat: -19.7620, lng: -47.9620 },
  { nome: 'Beija-Flor', population: 19000, lat: -19.7120, lng: -47.9750 },
  { nome: 'Jardim Uberaba', population: 12000, lat: -19.7680, lng: -47.9420 },
  { nome: 'Santa Marta', population: 11000, lat: -19.7550, lng: -47.9650 }
];

const GOV_VALADARES_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Centro', population: 35000, lat: -18.8511, lng: -41.9494 },
  { nome: 'Ilha dos Araújos', population: 12000, lat: -18.8580, lng: -41.9410 },
  { nome: 'Esplanada', population: 18000, lat: -18.8420, lng: -41.9520 },
  { nome: 'Vila Bretas', population: 22000, lat: -18.8380, lng: -41.9420 },
  { nome: 'Lourdes', population: 15000, lat: -18.8620, lng: -41.9550 },
  { nome: 'Grã-Duquesa', population: 14000, lat: -18.8350, lng: -41.9620 },
  { nome: 'Morada do Vale', population: 13000, lat: -18.8280, lng: -41.9580 },
  { nome: 'São Pedro', population: 20000, lat: -18.8680, lng: -41.9680 },
  { nome: 'Santa Rita', population: 25000, lat: -18.8750, lng: -41.9580 },
  { nome: 'Carapina', population: 16000, lat: -18.8450, lng: -41.9320 },
  { nome: 'Altinópolis', population: 19000, lat: -18.8320, lng: -41.9250 },
  { nome: 'Jardim Pérola', population: 21000, lat: -18.8650, lng: -41.9820 },
  { nome: 'Santos Dumont', population: 17000, lat: -18.8820, lng: -41.9450 }
];

const IPATINGA_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Centro', population: 20000, lat: -19.4686, lng: -42.5369 },
  { nome: 'Horto', population: 15000, lat: -19.4820, lng: -42.5280 },
  { nome: 'Cariru', population: 12000, lat: -19.4920, lng: -42.5180 },
  { nome: 'Bom Retiro', population: 14000, lat: -19.4750, lng: -42.5220 },
  { nome: 'Imbaúbas', population: 11000, lat: -19.4880, lng: -42.5280 },
  { nome: 'Castelo', population: 10000, lat: -19.4820, lng: -42.5120 },
  { nome: 'Iguaçu', population: 22000, lat: -19.4720, lng: -42.5480 },
  { nome: 'Ideal', population: 18000, lat: -19.4620, lng: -42.5520 },
  { nome: 'Canaã', population: 28000, lat: -19.4520, lng: -42.5620 },
  { nome: 'Bethânia', population: 35000, lat: -19.4420, lng: -42.5720 },
  { nome: 'Vila Celeste', population: 20000, lat: -19.4580, lng: -42.5420 },
  { nome: 'Cidade Nobre', population: 25000, lat: -19.4680, lng: -42.5580 },
  { nome: 'Esperança', population: 22000, lat: -19.4380, lng: -42.5520 },
  { nome: 'Limoeiro', population: 16000, lat: -19.4320, lng: -42.5820 }
];

const SETE_LAGOAS_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Centro', population: 30000, lat: -19.4658, lng: -44.2467 },
  { nome: 'Canaã', population: 22000, lat: -19.4520, lng: -44.2380 },
  { nome: 'Boa Vista', population: 18000, lat: -19.4580, lng: -44.2520 },
  { nome: 'Santo Antônio', population: 16000, lat: -19.4720, lng: -44.2420 },
  { nome: 'Nossa Senhora das Graças', population: 15000, lat: -19.4780, lng: -44.2520 },
  { nome: 'Progresso', population: 20000, lat: -19.4420, lng: -44.2580 },
  { nome: 'Carmo', population: 14000, lat: -19.4680, lng: -44.2350 },
  { nome: 'Interlagos', population: 17000, lat: -19.4850, lng: -44.2620 },
  { nome: 'Nova Cidade', population: 25000, lat: -19.4280, lng: -44.2680 },
  { nome: 'Jardim Cambuí', population: 12000, lat: -19.4550, lng: -44.2280 },
  { nome: 'Eldorado', population: 18000, lat: -19.4380, lng: -44.2380 },
  { nome: 'Cidade de Deus', population: 21000, lat: -19.4180, lng: -44.2780 }
];

const DIVINOPOLIS_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  { nome: 'Centro', population: 35000, lat: -20.1428, lng: -44.8872 },
  { nome: 'Bom Pastor', population: 22000, lat: -20.1520, lng: -44.8810 },
  { nome: 'Sidil', population: 12000, lat: -20.1380, lng: -44.8820 },
  { nome: 'Porto Velho', population: 15000, lat: -20.1480, lng: -44.8720 },
  { nome: 'Interlagos', population: 18000, lat: -20.1620, lng: -44.8980 },
  { nome: 'Niterói', population: 20000, lat: -20.1320, lng: -44.8720 },
  { nome: 'Afonso Pena', population: 16000, lat: -20.1280, lng: -44.8850 },
  { nome: 'Planalto', population: 19000, lat: -20.1580, lng: -44.9080 },
  { nome: 'Santa Clara', population: 14000, lat: -20.1450, lng: -44.8950 },
  { nome: 'Belvedere', population: 17000, lat: -20.1680, lng: -44.9120 },
  { nome: 'São José', population: 21000, lat: -20.1220, lng: -44.8920 },
  { nome: 'Catalão', population: 13000, lat: -20.1350, lng: -44.8980 }
];

const CITY_CENTER_COORDS: Record<number, { lat: number; lng: number }> = {
  3106200: { lat: -19.9167, lng: -43.9345 }, // BH
  3118601: { lat: -19.9318, lng: -44.0536 }, // Contagem
  3118600: { lat: -19.9318, lng: -44.0536 },
  3106705: { lat: -19.9676, lng: -44.2001 }, // Betim
  3106700: { lat: -19.9676, lng: -44.2001 },
  3170206: { lat: -18.9186, lng: -48.2772 }, // Uberlândia
  3136702: { lat: -21.7642, lng: -43.3503 }, // Juiz de Fora
  3143302: { lat: -16.7282, lng: -43.8578 }, // Montes Claros
  3170107: { lat: -19.7483, lng: -47.9319 }, // Uberaba
  3127701: { lat: -18.8511, lng: -41.9494 }, // Gov. Valadares
  3131307: { lat: -19.4686, lng: -42.5369 }, // Ipatinga
  3167202: { lat: -19.4658, lng: -44.2467 }, // Sete Lagoas
  3122306: { lat: -20.1428, lng: -44.8872 }, // Divinópolis
  3154606: { lat: -19.7669, lng: -44.0867 }, // Ribeirão das Neves
  3157807: { lat: -19.7697, lng: -43.8514 }, // Santa Luzia
  3151800: { lat: -21.7853, lng: -46.5653 }, // Poços de Caldas
  3148004: { lat: -18.5789, lng: -46.5181 }, // Patos de Minas
  3152501: { lat: -22.2300, lng: -45.9364 }, // Pouso Alegre
  3170701: { lat: -21.5514, lng: -45.4328 }, // Varginha
  3156700: { lat: -19.8914, lng: -43.8064 }, // Sabará
  3129806: { lat: -20.0219, lng: -44.0589 }, // Ibirité
  3118304: { lat: -20.6603, lng: -43.7864 }, // Conselheiro Lafaiete
  3103504: { lat: -18.6486, lng: -48.1928 }, // Araguari
  3147907: { lat: -20.7189, lng: -46.6097 }, // Passos
  3105608: { lat: -21.2258, lng: -43.7736 }, // Barbacena
  3550308: { lat: -23.5505, lng: -46.6333 }, // São Paulo
  3304557: { lat: -22.9068, lng: -43.1729 }, // Rio de Janeiro
  5300108: { lat: -15.7975, lng: -47.8919 }, // Brasília
  2927408: { lat: -12.9777, lng: -38.5016 }, // Salvador
  2304400: { lat: -3.7319, lng: -38.5267 },  // Fortaleza
  4106902: { lat: -25.4284, lng: -49.2733 }, // Curitiba
  2611606: { lat: -8.0476, lng: -34.8770 },  // Recife
  4314902: { lat: -30.0346, lng: -51.2177 }, // Porto Alegre
  5208707: { lat: -16.6869, lng: -49.2648 }, // Goiânia
  3205309: { lat: -20.3155, lng: -40.3128 }  // Vitória
};

const BRAZIL_STATES: IBGEState[] = [
  { id: 12, sigla: 'AC', nome: 'Acre' },
  { id: 27, sigla: 'AL', nome: 'Alagoas' },
  { id: 16, sigla: 'AP', nome: 'Amapá' },
  { id: 13, sigla: 'AM', nome: 'Amazonas' },
  { id: 29, sigla: 'BA', nome: 'Bahia' },
  { id: 23, sigla: 'CE', nome: 'Ceará' },
  { id: 53, sigla: 'DF', nome: 'Distrito Federal' },
  { id: 32, sigla: 'ES', nome: 'Espírito Santo' },
  { id: 52, sigla: 'GO', nome: 'Goiás' },
  { id: 21, sigla: 'MA', nome: 'Maranhão' },
  { id: 51, sigla: 'MT', nome: 'Mato Grosso' },
  { id: 50, sigla: 'MS', nome: 'Mato Grosso do Sul' },
  { id: 31, sigla: 'MG', nome: 'Minas Gerais' },
  { id: 15, sigla: 'PA', nome: 'Pará' },
  { id: 25, sigla: 'PB', nome: 'Paraíba' },
  { id: 41, sigla: 'PR', nome: 'Paraná' },
  { id: 26, sigla: 'PE', nome: 'Pernambuco' },
  { id: 22, sigla: 'PI', nome: 'Piauí' },
  { id: 33, sigla: 'RJ', nome: 'Rio de Janeiro' },
  { id: 24, sigla: 'RN', nome: 'Rio Grande do Norte' },
  { id: 43, sigla: 'RS', nome: 'Rio Grande do Sul' },
  { id: 11, sigla: 'RO', nome: 'Rondônia' },
  { id: 14, sigla: 'RR', nome: 'Roraima' },
  { id: 42, sigla: 'SC', nome: 'Santa Catarina' },
  { id: 35, sigla: 'SP', nome: 'São Paulo' },
  { id: 28, sigla: 'SE', nome: 'Sergipe' },
  { id: 17, sigla: 'TO', nome: 'Tocantins' }
];

class IBGEService {
  private baseUrl = 'https://servicodados.ibge.gov.br/api/v1/localidades';

  async getStates(): Promise<IBGEState[]> {
    return BRAZIL_STATES.sort((a, b) => a.nome.localeCompare(b.nome));
  }

  async getCities(stateSigla: string): Promise<IBGECity[]> {
    let cities: IBGECity[] = [];
    try {
      const controller = new AbortController();
      const id = setTimeout(() => controller.abort(), 10000); // 10s timeout
      
      const res = await fetch(`${this.baseUrl}/estados/${stateSigla}/municipios?orderBy=nome`, {
        signal: controller.signal
      });
      clearTimeout(id);
      
      if (res.ok) {
        cities = await res.json();
      } else {
        throw new Error('Falha ao buscar cidades do IBGE');
      }
    } catch (e) {
      console.warn('Fallback para BrasilAPI nas cidades...', e);
      try {
        const res = await fetch(`https://brasilapi.com.br/api/ibge/municipios/v1/${stateSigla}?providers=dados-abertos-br,gov,wikipedia`);
        if (res.ok) {
          const data = await res.json();
          cities = data.map((city: any) => ({
            id: parseInt(city.codigo_ibge, 10),
            nome: city.nome
          }));
        }
      } catch (err) {
        console.warn('Falha nas APIs externas de cidade, usando armazenadas.', err);
      }
    }

    const custom = this.customCitiesByState.get(stateSigla.trim().toUpperCase()) || [];
    custom.forEach(c => {
      if (!cities.some(item => item.nome.toLowerCase() === c.nome.toLowerCase())) {
        cities.push(c);
      }
    });

    return cities.sort((a, b) => a.nome.localeCompare(b.nome));
  }

  private customNeighborhoodsByCity: Map<string, IBGEDistrict[]> = new Map();
  private customCitiesByState: Map<string, IBGECity[]> = new Map();

  public registerCustomNeighborhoods(cityName: string, bairros: Array<{nome: string, lat?: number, lng?: number, population?: number}>) {
    if (!cityName || !bairros || bairros.length === 0) return;
    const key = cityName.trim().toLowerCase();
    const existing = this.customNeighborhoodsByCity.get(key) || [];
    
    bairros.forEach((b, idx) => {
      const bNameClean = b.nome.trim();
      const existingIdx = existing.findIndex(e => e.nome.toLowerCase() === bNameClean.toLowerCase());
      const districtObj: IBGEDistrict = {
        id: existingIdx >= 0 ? existing[existingIdx].id : 990000 + Math.floor(Math.random() * 800000),
        nome: bNameClean,
        lat: b.lat,
        lng: b.lng,
        population: b.population || 10000
      };
      if (existingIdx >= 0) {
        existing[existingIdx] = { ...existing[existingIdx], ...districtObj };
      } else {
        existing.push(districtObj);
      }
    });

    this.customNeighborhoodsByCity.set(key, existing);
    this.saveCustomToLocalStorage();
  }

  public registerCustomCities(stateSigla: string, cities: Array<{id?: number, nome: string}>) {
    if (!stateSigla || !cities || cities.length === 0) return;
    const key = stateSigla.trim().toUpperCase();
    const existing = this.customCitiesByState.get(key) || [];

    cities.forEach(c => {
      const cNameClean = c.nome.trim();
      if (!existing.some(e => e.nome.toLowerCase() === cNameClean.toLowerCase())) {
        existing.push({
          id: c.id || Math.floor(Math.random() * 800000) + 100000,
          nome: cNameClean
        });
      }
    });

    this.customCitiesByState.set(key, existing);
    this.saveCustomToLocalStorage();
  }

  private saveCustomToLocalStorage() {
    try {
      const nhObj: Record<string, IBGEDistrict[]> = {};
      this.customNeighborhoodsByCity.forEach((val, key) => { nhObj[key] = val; });
      localStorage.setItem('google_maps_custom_neighborhoods', JSON.stringify(nhObj));

      const cityObj: Record<string, IBGECity[]> = {};
      this.customCitiesByState.forEach((val, key) => { cityObj[key] = val; });
      localStorage.setItem('google_maps_custom_cities', JSON.stringify(cityObj));
    } catch (e) {
      console.warn('Failed to save custom IBGE data to localStorage', e);
    }
  }

  private loadCustomFromLocalStorage() {
    try {
      const nhSaved = localStorage.getItem('google_maps_custom_neighborhoods');
      if (nhSaved) {
        const parsed = JSON.parse(nhSaved);
        Object.keys(parsed).forEach(k => this.customNeighborhoodsByCity.set(k, parsed[k]));
      }
      const citySaved = localStorage.getItem('google_maps_custom_cities');
      if (citySaved) {
        const parsed = JSON.parse(citySaved);
        Object.keys(parsed).forEach(k => this.customCitiesByState.set(k, parsed[k]));
      }
    } catch (e) {
      console.warn('Failed to load custom IBGE data from localStorage', e);
    }
  }

  public getKnownNeighborhoodsForCity(cityName: string, stateSigla?: string): Array<{nome: string, lat?: number, lng?: number, population?: number}> | null {
    if (!cityName) return null;
    const clean = cityName.trim().toLowerCase();

    // 1. Custom registrados
    const custom = this.customNeighborhoodsByCity.get(clean);
    if (custom && custom.length > 0) {
      return custom.map(c => ({ nome: c.nome, lat: c.lat, lng: c.lng, population: c.population }));
    }

    // 2. Curadoria oficial integrada
    if (clean === 'são paulo' || clean === 'sao paulo' || clean === 'sp' || (clean === 'são paulo' && (!stateSigla || stateSigla.toUpperCase() === 'SP'))) {
      return SAO_PAULO_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'belo horizonte' || clean === 'bh' || (clean === 'belo horizonte' && (!stateSigla || stateSigla.toUpperCase() === 'MG'))) {
      return BH_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'contagem') {
      return CONTAGEM_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'betim') {
      return BETIM_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'uberlândia' || clean === 'uberlandia') {
      return UBERLANDIA_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'juiz de fora') {
      return JUIZ_DE_FORA_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'rio de janeiro' || clean === 'rj' || (clean === 'rio de janeiro' && (!stateSigla || stateSigla.toUpperCase() === 'RJ'))) {
      return RIO_DE_JANEIRO_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'brasília' || clean === 'brasilia' || clean === 'df' || clean === 'distrito federal' || (clean === 'brasília' && (!stateSigla || stateSigla.toUpperCase() === 'DF'))) {
      return BRASILIA_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'salvador' || clean === 'ssa' || (clean === 'salvador' && (!stateSigla || stateSigla.toUpperCase() === 'BA'))) {
      return SALVADOR_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'fortaleza' || clean === 'for' || (clean === 'fortaleza' && (!stateSigla || stateSigla.toUpperCase() === 'CE'))) {
      return FORTALEZA_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'curitiba' || clean === 'cwb' || (clean === 'curitiba' && (!stateSigla || stateSigla.toUpperCase() === 'PR'))) {
      return CURITIBA_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'porto alegre' || clean === 'poa' || (clean === 'porto alegre' && (!stateSigla || stateSigla.toUpperCase() === 'RS'))) {
      return PORTO_ALEGRE_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'goiânia' || clean === 'goiania' || clean === 'gyn' || (clean === 'goiânia' && (!stateSigla || stateSigla.toUpperCase() === 'GO'))) {
      return GOIANIA_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    if (clean === 'recife' || clean === 'rec' || (clean === 'recife' && (!stateSigla || stateSigla.toUpperCase() === 'PE'))) {
      return RECIFE_NEIGHBORHOODS.map(nh => ({
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      }));
    }

    return null;
  }

  constructor() {
    this.loadCustomFromLocalStorage();
  }

  private async fetchOverpassNeighborhoods(cityName: string, stateSigla?: string): Promise<Partial<IBGEDistrict>[]> {
    try {
      const cleanCity = cityName.replace(/\s*\([A-Z]{2}\)\s*/i, '').trim();
      const query = `[out:json][timeout:15];
(
  area["name"="${cleanCity}"]["admin_level"="8"];
  area["name"="${cleanCity}"]["boundary"="administrative"];
)->.searchArea;
(
  node["place"~"suburb|neighbourhood|quarter"](area.searchArea);
  way["place"~"suburb|neighbourhood|quarter"](area.searchArea);
  relation["place"~"suburb|neighbourhood|quarter"](area.searchArea);
  relation["boundary"="administrative"]["admin_level"~"9|10"](area.searchArea);
);
out center;`;

      const url = `https://overpass-api.de/api/interpreter?data=${encodeURIComponent(query)}`;
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 12000);

      const response = await fetch(url, { signal: controller.signal });
      clearTimeout(timeoutId);

      if (!response.ok) return [];
      const json = await response.json();
      if (!json.elements || !Array.isArray(json.elements)) return [];

      const results: Partial<IBGEDistrict>[] = [];
      const seen = new Set<string>();

      for (const el of json.elements) {
        // [BLINDAGEM ANTI-RUA 1]: Rejeita estritamente qualquer entidade que possua tags de vias ou tráfego
        if (el.tags?.highway || el.tags?.road || el.tags?.railway || el.tags?.bridge || el.tags?.tunnel || el.tags?.route) {
          continue;
        }

        const rawName = el.tags?.name || el.tags?.['name:pt'];
        if (!rawName || typeof rawName !== 'string') continue;
        
        const cleanName = rawName.trim();
        const lower = cleanName.toLowerCase();

        // [BLINDAGEM ANTI-RUA 2]: Rejeita se o nome começar com termos típicos de logradouro/rua/avenida
        const isStreetName = /^(rua|r\.|av\.|avenida|alameda|al\.|travessa|trv\.|praça|pr\.|rodovia|rod\.|estrada|est\.|viaduto|vdt\.|beco|passarela|largo)\s+/i.test(cleanName);
        if (isStreetName) {
          continue;
        }

        const normKey = cleanName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        
        if (seen.has(normKey) || cleanName.length < 2) continue;
        seen.add(normKey);

        const lat = el.lat || (el.center && el.center.lat);
        const lng = el.lon || (el.center && el.center.lon);

        results.push({
          nome: cleanName,
          lat: typeof lat === 'number' ? lat : undefined,
          lng: typeof lng === 'number' ? lng : undefined
        });
      }

      return results;
    } catch (e) {
      console.warn('Overpass OSM fetch fallback/timeout:', e);
      return [];
    }
  }

  async getNeighborhoods(cityId: number, cityNameHint?: string, stateSigla?: string, forceRefresh = false): Promise<IBGEDistrict[]> {
    const cacheKey = `google_maps_complete_nh_${cityId}_${(cityNameHint || '').toLowerCase().trim()}`;
    
    if (!forceRefresh) {
      try {
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          const parsed = JSON.parse(cached);
          if (Array.isArray(parsed) && parsed.length > 0) {
            return parsed;
          }
        }
      } catch (e) {}
    }

    // 1. Verifica bairros cadastrados manualmente/customizados
    if (cityNameHint) {
      const customForCity = this.customNeighborhoodsByCity.get(cityNameHint.toLowerCase().trim());
      if (customForCity && customForCity.length > 0) {
        return customForCity;
      }
    }

    // 2. Curadoria histórica especial (mantida 100% intacta)
    if (cityId === 3550308 || (cityNameHint && cityNameHint.toLowerCase().trim() === 'são paulo') || (cityNameHint && cityNameHint.toLowerCase().trim() === 'sao paulo')) {
      return SAO_PAULO_NEIGHBORHOODS.map((nh, idx) => ({
        id: 950000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3106200) {
      return BH_NEIGHBORHOODS.map((nh, idx) => ({
        id: 900000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3118601 || cityId === 3118600) {
      return CONTAGEM_NEIGHBORHOODS.map((nh, idx) => ({
        id: 800000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3106705 || cityId === 3106700) {
      return BETIM_NEIGHBORHOODS.map((nh, idx) => ({
        id: 700000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3170206) {
      return UBERLANDIA_NEIGHBORHOODS.map((nh, idx) => ({
        id: 600000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3136702) {
      return JUIZ_DE_FORA_NEIGHBORHOODS.map((nh, idx) => ({
        id: 500000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3143302) {
      return MONTES_CLAROS_NEIGHBORHOODS.map((nh, idx) => ({
        id: 400000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3170107) {
      return UBERABA_NEIGHBORHOODS.map((nh, idx) => ({
        id: 300000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3127701) {
      return GOV_VALADARES_NEIGHBORHOODS.map((nh, idx) => ({
        id: 200000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3131307) {
      return IPATINGA_NEIGHBORHOODS.map((nh, idx) => ({
        id: 150000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3167202) {
      return SETE_LAGOAS_NEIGHBORHOODS.map((nh, idx) => ({
        id: 140000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3122306) {
      return DIVINOPOLIS_NEIGHBORHOODS.map((nh, idx) => ({
        id: 130000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 3304557 || (cityNameHint && (cityNameHint.toLowerCase().trim() === 'rio de janeiro' || cityNameHint.toLowerCase().trim() === 'rj'))) {
      return RIO_DE_JANEIRO_NEIGHBORHOODS.map((nh, idx) => ({
        id: 330000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 5300108 || (cityNameHint && (cityNameHint.toLowerCase().trim() === 'brasília' || cityNameHint.toLowerCase().trim() === 'brasilia' || cityNameHint.toLowerCase().trim() === 'distrito federal' || cityNameHint.toLowerCase().trim() === 'df'))) {
      return BRASILIA_NEIGHBORHOODS.map((nh, idx) => ({
        id: 530000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 2927408 || (cityNameHint && (cityNameHint.toLowerCase().trim() === 'salvador' || cityNameHint.toLowerCase().trim() === 'ssa'))) {
      return SALVADOR_NEIGHBORHOODS.map((nh, idx) => ({
        id: 290000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 2304400 || (cityNameHint && (cityNameHint.toLowerCase().trim() === 'fortaleza' || cityNameHint.toLowerCase().trim() === 'for'))) {
      return FORTALEZA_NEIGHBORHOODS.map((nh, idx) => ({
        id: 230000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 4106902 || (cityNameHint && (cityNameHint.toLowerCase().trim() === 'curitiba' || cityNameHint.toLowerCase().trim() === 'cwb'))) {
      return CURITIBA_NEIGHBORHOODS.map((nh, idx) => ({
        id: 410000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 4314902 || (cityNameHint && (cityNameHint.toLowerCase().trim() === 'porto alegre' || cityNameHint.toLowerCase().trim() === 'poa'))) {
      return PORTO_ALEGRE_NEIGHBORHOODS.map((nh, idx) => ({
        id: 430000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 5208707 || (cityNameHint && (cityNameHint.toLowerCase().trim() === 'goiânia' || cityNameHint.toLowerCase().trim() === 'goiania' || cityNameHint.toLowerCase().trim() === 'gyn'))) {
      return GOIANIA_NEIGHBORHOODS.map((nh, idx) => ({
        id: 520000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    if (cityId === 2611606 || (cityNameHint && (cityNameHint.toLowerCase().trim() === 'recife' || cityNameHint.toLowerCase().trim() === 'rec'))) {
      return RECIFE_NEIGHBORHOODS.map((nh, idx) => ({
        id: 260000 + idx,
        nome: nh.nome!,
        lat: nh.lat,
        lng: nh.lng,
        population: nh.population
      })).sort((a, b) => (b.population || 0) - (a.population || 0));
    }

    // 3. Busca em paralelo: IBGE + OpenStreetMap (Overpass)
    let ibgeData: any[] = [];
    const baseCoords = CITY_CENTER_COORDS[cityId] || { lat: -23.5505, lng: -46.6333 };

    try {
      const [distritosRes, bairrosRes] = await Promise.allSettled([
        fetch(`${this.baseUrl}/municipios/${cityId}/distritos`),
        fetch(`${this.baseUrl}/municipios/${cityId}/bairros`)
      ]);

      if (bairrosRes.status === 'fulfilled' && bairrosRes.value.ok) {
        const b = await bairrosRes.value.json();
        if (Array.isArray(b)) ibgeData.push(...b);
      }

      if (distritosRes.status === 'fulfilled' && distritosRes.value.ok) {
        const d = await distritosRes.value.json();
        if (Array.isArray(d)) ibgeData.push(...d);
      }
    } catch (e) {
      console.warn('IBGE fetch error:', e);
    }

    // 4. Se temos o nome da cidade, complementa com OpenStreetMap (Overpass) para capturar 100% dos bairros
    let osmData: Partial<IBGEDistrict>[] = [];
    if (cityNameHint) {
      osmData = await this.fetchOverpassNeighborhoods(cityNameHint, stateSigla);
    }

    // 5. Mesclagem inteligente e deduplicação
    const combinedMap = new Map<string, IBGEDistrict>();
    let generatedIdCounter = 10000;

    // Primeiro injeta dados do OpenStreetMap (que trazem coordenadas precisas)
    osmData.forEach((nh, idx) => {
      if (!nh.nome) return;
      const normKey = nh.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      combinedMap.set(normKey, {
        id: 500000 + idx,
        nome: nh.nome,
        lat: nh.lat || baseCoords.lat + (Math.random() - 0.5) * 0.06,
        lng: nh.lng || baseCoords.lng + (Math.random() - 0.5) * 0.06
      });
    });

    // Depois complementa com dados do IBGE (se já existir, mantém coordenadas do OSM)
    ibgeData.forEach(item => {
      if (!item.nome) return;
      const normKey = item.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      if (!combinedMap.has(normKey)) {
        combinedMap.set(normKey, {
          id: item.id || ++generatedIdCounter,
          nome: item.nome,
          lat: baseCoords.lat + (Math.random() - 0.5) * 0.08,
          lng: baseCoords.lng + (Math.random() - 0.5) * 0.08
        });
      }
    });

    const finalResult = Array.from(combinedMap.values()).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));

    // 6. Salva no cache local para resposta instantânea nas próximas aberturas
    if (finalResult.length > 0) {
      try {
        localStorage.setItem(cacheKey, JSON.stringify(finalResult));
      } catch (e) {}
    }

    return finalResult;
  }

  /**
   * Mescla e salva bairros enriquecidos pela IA no cache da cidade
   */
  public saveAiNeighborhoods(cityId: number, aiNeighborhoods: { nome: string; lat?: number; lng?: number; population?: number }[]): IBGEDistrict[] {
    const cacheKey = `nh_cache_${cityId}`;
    let current: IBGEDistrict[] = [];
    try {
      const saved = localStorage.getItem(cacheKey);
      if (saved) current = JSON.parse(saved);
    } catch (e) {}

    const combinedMap = new Map<string, IBGEDistrict>();
    current.forEach(nh => {
      const norm = nh.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      combinedMap.set(norm, nh);
    });

    let idCounter = 600000;
    aiNeighborhoods.forEach(item => {
      if (!item.nome) return;
      const norm = item.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      if (!combinedMap.has(norm)) {
        combinedMap.set(norm, {
          id: ++idCounter,
          nome: item.nome,
          lat: item.lat,
          lng: item.lng,
          population: item.population
        });
      } else if (item.lat && item.lng) {
        const exist = combinedMap.get(norm)!;
        exist.lat = item.lat;
        exist.lng = item.lng;
      }
    });

    const updated = Array.from(combinedMap.values()).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    try {
      localStorage.setItem(cacheKey, JSON.stringify(updated));
    } catch (e) {}

    return updated;
  }

  /**
   * Verifica se a cidade já possui lista de bairros mapeada (pelo cache ou listas curadas)
   */
   public isCityNeighborhoodsMapped(cityId: number | string): boolean {
     const id = Number(cityId);
     const cacheKey = `nh_cache_${id}`;
     try {
       const saved = localStorage.getItem(cacheKey);
       if (saved) {
         const parsed = JSON.parse(saved);
         if (Array.isArray(parsed) && parsed.length > 0) return true;
       }
     } catch (e) {}

     // Cidades com listas curadas oficiais
     if ([
       3550308, // São Paulo - SP
       3304557, // Rio de Janeiro - RJ
       5300108, // Brasília - DF
       2927408, // Salvador - BA
       2304400, // Fortaleza - CE
       4106902, // Curitiba - PR
       4314902, // Porto Alegre - RS
       5208707, // Goiânia - GO
       2611606, // Recife - PE
       3106200, // Belo Horizonte - MG
       3118601, 3118600, // Contagem - MG
       3106705, 3106700, // Betim - MG
       3170206, // Uberlândia - MG
       3136702, // Juiz de Fora - MG
       3143302, // Montes Claros - MG
       3170107, // Uberaba - MG
       3127701, // Gov. Valadares - MG
       3131307, // Ipatinga - MG
       3167202, // Sete Lagoas - MG
       3122306  // Divinópolis - MG
     ].includes(id)) {
       return true;
     }

     return false;
   }

   public getCachedNeighborhoods(cityId: number | string): IBGEDistrict[] {
     const id = Number(cityId);
     const cacheKey = `nh_cache_${id}`;
     try {
       const saved = localStorage.getItem(cacheKey);
       if (saved) {
         const parsed = JSON.parse(saved);
         if (Array.isArray(parsed)) return parsed;
       }
     } catch (e) {}
     return [];
   }

  getAgeGroups(): IBGEDemographic {
    return {
      id: 'age',
      label: 'Faixa Etária',
      options: [
        { id: '18-24', label: '18 a 24 anos' },
        { id: '25-34', label: '25 a 34 anos' },
        { id: '35-44', label: '35 a 44 anos' },
        { id: '45-54', label: '45 a 54 anos' },
        { id: '55-64', label: '55 a 64 anos' },
        { id: '65+', label: '65 anos ou mais' }
      ]
    };
  }

  getIncomeGroups(): IBGEDemographic {
    return {
      id: 'income',
      label: 'Classe Social (Estimada)',
      options: [
        { id: 'A', label: 'Classe A (> 20 SM)' },
        { id: 'B', label: 'Classe B (10 a 20 SM)' },
        { id: 'C', label: 'Classe C (4 a 10 SM)' },
        { id: 'D', label: 'Classe D (2 a 4 SM)' },
        { id: 'E', label: 'Classe E (até 2 SM)' }
      ]
    };
  }
}

export const ibgeService = new IBGEService();
